export const technologyBreakpoint = 1100;